"use strict";

import { message } from '../message';
import { HeaderNotification} from "./modules/header";

export class Init {
    constructor(options) {
        this.userId = options.userId;
        this.wsUrl = options.wsUrl;
        this.notificationUrl = options.notificationUrl;
        this.checkUnreadUrl = options.checkUnreadUrl;

        this.init();
    }

    init() {
        // init notification in header mail block
        new HeaderNotification(this.checkUnreadUrl);

        // init websocket connection
        let ws = new WebSocket(this.wsUrl);
        this.addEvents(ws);
    }

    addEvents(ws) {
        ws.onopen = () => {
            ws.send(this.userId);
        };

        ws.onclose = () => {
            // reconnect
            setTimeout(() => this.init(), 5000);
        };

        ws.onmessage = event => {
            let messageId = JSON.parse(event.data);

            $.ajax({
                type: "GET",
                url: this.notificationUrl + '/' + messageId,
                success: (data) => {
                    if (data.success) {

                        let url = window.location.pathname;
                        // check chat and show only on chat page
                        if (url.indexOf("/chat/") !== -1 && Number(url.split('/').pop()) === data.from) {
                            let newMessage = $(data.messageHtml).hide();

                            if (data.isInvite && !data.isCompany) {
                                $('#invite-cooperation-block').append(newMessage);
                            } else {
                                $('#chat-list-body').append(newMessage);
                            }

                            newMessage.slideDown();
                            message.scroll();
                        }

                        // show unread notification in header mail block
                        $('#new-message-notification').css('display', 'flex');
                    }
                }
            })
        };
    }
}